<template lang="pug">
.reports-table
    page(v-if="!reportItemsFiltered.length")
        empty No reports found
    el-table(v-loading="loading", :data="reportItemsFilteredPage", @sort-change="handleSort", @row-click='rowClick', v-else)
        el-table-column(label='School', property="school_name", :show-overflow-tooltip="true")
            template(slot-scope="scope")
                strong.school_name {{ scope.row.school_name }}
        el-table-column(property="report_name", label="Type", sortable)
            template(slot-scope="scope")
                span {{ formatReportName(scope.row.report_name) }}
        el-table-column(property="status", label="Status", sortable,  :filters="reportFilters" :filter-method="filterType" filter-placement="bottom-end")
            template(slot-scope="scope")
                el-tag(size="small", :type="reportStatus(scope.row.status)") {{ scope.row.status | capitalise}}
        el-table-column(label="Report" sortable)
            template(slot-scope="scope")
                span {{ scope.row.queue.includes('urgent') ? 'Manual' : 'Scheduled' }}
        el-table-column(property="created_at", label="Run at" sortable)
            template(slot-scope="scope") {{ scope.row.run_at | standard_datetime }}
    pagination(v-if="!$apollo.loading && reportItemsFiltered.length")
        el-pagination(layout='prev, pager, next', background, :page-size="pageSize", :current-page="currentPage" :total='reportItemsCount', @current-change="handleCurrentChange")
</template>

<script>
import { orderBy, chunk, filter, every } from "lodash";

export default {
	name: "ReportsTable",
	props: ["reports", "loading"],
	data() {
		return {
			pageSize: 30,
			search: {
				school_name: null,
				company_name: null
			},
			reportFilters: [
				{ text: "Queued", value: "queued" },
				{ text: "Accepted", value: "accepted" },
				{ text: "Running", value: "running" },
				{ text: "Failing", value: "failing" },
				{ text: "Failed", value: "failed" },
				{ text: "Finished", value: "finished" },
				{ text: "Error", value: "exception" }
			]
		};
	},
	computed: {
		currentPage: {
			get() {
				if (this.$route.query.page) {
					return parseInt(this.$route.query.page);
				}
				return 1;
			},
			set(value) {
				this.$router.push({ query: { ...this.$route.query, page: value } });
			}
		},
		reportItemsFiltered() {
			if (this.reports) {
				let items = this.reports;
				if (this.search.school_name || this.search.company_name) {
					items = filter(items, item => {
						let checkArray = [true];
						if (this.search.school_name) {
							checkArray.push(item.school_name.toLowerCase().includes(this.search.school_name.toLowerCase()));
						}
						if (this.search.company_name) {
							checkArray.push(item.company_name.toLowerCase().includes(this.search.company_name.toLowerCase()));
						}
						return every(checkArray);
					});
				}
				return items;
			}
			return [];
		},
		reportItemsFilteredPage() {
			if (this.reportItemsFiltered) {
				let chunkedItems = chunk(this.reportItemsFiltered, this.pageSize);
				return chunkedItems[this.currentPage - 1];
			}
			return [];
		},
		reportItemsCount() {
			if (this.reportItemsFiltered) {
				return this.reportItemsFiltered.length;
			}
			return 0;
		}
	},

	methods: {
		formatReportName(name) {
			return name
				.split("_")
				.map(word => word.charAt(0).toUpperCase() + word.slice(1))
				.join(" ");
		},
		filterType(value, row) {
			return row.status === value;
		},
		rowClick(row) {
			this.$router.push({ name: "schools.show", params: { school: row.school_id } });
		},
		handleCurrentChange(page) {
			this.$router.push({ query: { ...this.$route.query, page: page } });
		},
		handleSort({ prop, order }) {
			order = order == "ascending" ? "asc" : "desc";
			this.reports = orderBy(this.reports, prop, order);
			this.currentPage = 1;
		},
		reportStatus(type) {
			switch (type) {
				// case "requested":
				// 	tag = "primary";
				// 	break;
				case "queued":
					return "warning";
				case "finished":
					return "success";
				case "failed":
				case "failing":
					return "danger";
				default:
					return "info";
			}
		}
	}
};
</script>

<style language="css" scoped> 
.school_name {
	width: 270px;
	text-overflow: ellipsis;
	overflow:hidden;
	display: inline-block;
}
</style>
